if (!customElements.get('show-stock')) {
  customElements.define(
    'show-stock',
    class ProductOptions extends window.BAO.CustomElement {
      constructor() {
        super()
        this.initialiseShowStock()
      }

      initialiseShowStock() {

        const change = this.handleChange.bind(this)

        document.addEventListener('click', event => {
          if (event.target.closest('[data-size-guide-switch]')) this.fillMeasurements()
        })
        // watch for url changes
        let previousUrl = ''
        const observer = new MutationObserver(function(mutations) {
          if (window.location.href !== previousUrl) {
            previousUrl = window.location.href
            const url = window.location.href
            const searchParams = new URLSearchParams(new URL(url).search)
            const variantParam = searchParams.get("variant")

            change(variantParam)
          }
        })

        const config = { subtree: true, childList: true }
        observer.observe(document, config)
      }

      // Builds "Body Measurements: Chest: 42" | Waist: 34"" from the size guide's Body Measurement table,
      // matching each line's data-size to a table row. It uses whichever unit the size guide's in/cm
      // switch currently shows, and is rebuilt when that switch is clicked.
      fillMeasurements() {
        const panel = document.querySelector('[data-size-guide-switch]')?.closest('.prd-SizeGuideDrawer_Panel')
        const drawer = (panel || document).querySelector('[data-size-unit="body"]')
        const holder = drawer?.querySelector('[data-size-measure]:not([hidden])')
        const table = (holder || drawer)?.querySelector('table')
        if (!table) return

        const unit = holder?.dataset.sizeMeasure === 'cm' ? 'cm' : holder ? '"' : ''
        const rows = [...table.querySelectorAll('tr')]
        const headers = [...(rows[0]?.children || [])].map(cell => cell.textContent.trim())

        this.querySelectorAll('[data-size]').forEach(line => {
          const size = line.dataset.size.trim().toLowerCase()
          const row = rows.slice(1).find(
            tr => tr.children[0]?.textContent.trim().toLowerCase() === size
          )
          if (!row) return
          const parts = [...row.children]
            .slice(1)
            .map((cell, index) => {
              const value = cell.textContent.trim()
              if (!value) return ''
              return `${headers[index + 1]}: ${value}${/^[\d.\-–\/ ]+$/.test(value) ? unit : ''}`
            })
            .filter(Boolean)
          if (!parts.length) return
          line.textContent = `Body Measurements: ${parts.join(' | ')}`
          line.hidden = false
        })
      }

      handleChange(variantParam) {
        this.fillMeasurements()

        const generalStock = this.querySelector('.product-inventory')

        if (variantParam != null) {
          if (generalStock) {
            generalStock.classList.remove('stock-msg--show')
          }

          const stockMsgs = this.querySelectorAll('.variant-inventory')
          stockMsgs.forEach(el => el.classList.remove('stock-msg--show'))
          const stockMsg = this.querySelector(`.variant-inventory[data-variant-id="${variantParam}"]`)
          stockMsg?.classList.add('stock-msg--show')
        } else {
          generalStock?.classList.add('stock-msg--show')
        }
      }
    }
  )
}